export default function getConversionRate(conversions, visits) {
  if (!conversions || !visits) {
    return 0;
  }

  const conversionRate = (Number(conversions) / visits) * 100;

  // round conversionRate to max one decimals
  return Math.round(conversionRate * 10) / 10 || 0;
}
